import { addToCartData } from '@actions/userActions';
import { getFirestore, getDoc, updateDoc, doc, setDoc } from "firebase/firestore";
import { logError } from '@actions/userActions';

type SelectedVariants = {
    value: number;
    label: string;
};

type CartItem = {
    available?: boolean;
    variants?: null;
    image?: string;
    order?: number;
    type?: string;
    category?: string;
    name?: string;
    selectedVariants?: SelectedVariants;
    selected?: number;
    itemDescription?: string; // Kitchen instructions/description (for KOT only)
};

/** Merge source table cart into destination (adds quantities for matching keys). */
export function mergeTableCartItems(
    destObj: Record<string, CartItem | null | undefined> | undefined | null,
    srcObj: Record<string, CartItem | null | undefined> | undefined | null
): Record<string, CartItem | null> {
    const dest = destObj ?? {};
    const src = srcObj ?? {};

    if (!Object.keys(dest).length) {
        return { ...(src as Record<string, CartItem | null>) };
    }
    if (!Object.keys(src).length) {
        return { ...(dest as Record<string, CartItem | null>) };
    }

    const merged: Record<string, CartItem | null> = { ...(dest as Record<string, CartItem | null>) };
    Object.entries(src).forEach(([itemKey, itemDetails]) => {
        if (!itemDetails) return;
        const existing = merged[itemKey];
        if (existing) {
            merged[itemKey] = {
                ...existing,
                selected: (existing.selected || 0) + (itemDetails.selected || 0),
            };
        } else {
            merged[itemKey] = itemDetails;
        }
    });

    return merged;
}

type Cart = {
    [key: string]: {
        [key: string]: CartItem | null;
    };
};

export const mergeCartFunc = (localCart: Cart, remoteCart: Cart): Cart => {
    // console.log('localCart, remoteCart', localCart, remoteCart);
    const mergedCart: Cart = { ...localCart };

    for (const tableKey in remoteCart) {
        if (!remoteCart.hasOwnProperty(tableKey)) continue;

        if (!mergedCart[tableKey]) {
            mergedCart[tableKey] = { ...remoteCart[tableKey] };
        } else {
            for (const itemKey in remoteCart[tableKey]) {
                if (!remoteCart[tableKey].hasOwnProperty(itemKey)) continue;

                const localItem = mergedCart[tableKey][itemKey];
                const remoteItem = remoteCart[tableKey][itemKey];

                if (localItem && remoteItem) {
                    mergedCart[tableKey][itemKey] = {
                        ...localItem,
                        // selected: (localItem.selected || 0) + (remoteItem.selected || 0)
                        selected: Math.max(localItem.selected || 0, remoteItem.selected || 0)
                    };
                } else {
                    mergedCart[tableKey][itemKey] = localItem || remoteItem;
                }
            }
        }
    }

    return mergedCart;
};

export const addToCart = async (item: any, key: any, dispatch: any, tableNumber?: any, resId?: any) => {
    try {
        dispatch(addToCartData({ [key]: { ...item, selected: 1 } }, tableNumber, resId));
    } catch (e) {
        console.error("Error adding document: ", e);
    }
};

export const updateRemoteCartData = async (restaurantId: any, mergedCart: any, dispatch: any) => {
    const db = getFirestore();
    try {
        if (!restaurantId) {
            throw new Error("Invalid restaurant ID");
        }

        const docRef = doc(db, 'carts', restaurantId);

        // Check if the document exists
        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
            // Update the existing document
            await updateDoc(docRef, mergedCart);
        } else {
            // Create a new document with the same ID as restaurantId
            await setDoc(docRef, mergedCart);
        }

        dispatch(logError({ severity: 'success', message: "Sync success :)" }));

    } catch (error: any) {
        console.error(error);
        dispatch(logError({ severity: 'error', message: error?.message || 'NA' }));
    }
}

//-----
export const getRemoteCartData = async (restaurantId: any, _dispatch: any) => {
    const db = getFirestore();
    try {
        let data = {};
        if (restaurantId) {
            const snap = await getDoc(doc(db, 'carts', restaurantId))
            if (snap.exists()) {
                // console.log(snap.data())
                data = snap.data();
            }
            // console.log('data', restaurantId, data);
            if (data) {
                return data;
            }
            return {};
        }
        return {};
    } catch (e) {
        console.error("Error adding document: ", e);
    }
}
